/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from '../toast';
import * as userService from '../../../services/userService'
import { BASE_IMAGE_PATH } from '../../../configs/api';
class PasswordModel extends Component {
   constructor(props) {
      super(props);
      this.state = {
         passcode: "",
         repasscode: "",
         mpassword:"",
         toastMsg: "",
         toastType: ""
      };
   }
   showToast(msg, type) {
      let self = this
      this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
          setTimeout(() => {
              self.setState({ toastMsg: "", toastType: "", showToast: false })
          }, 3000);
      })
  }
   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value })
    }
    handleKey(e) {
      if (e.keyCode === 13) {
        this.submitForm();
      }
    }
    async submitForm() {
      if(this.state.loading){
         return false
      } else {
         this.setState({loading:true},async()=>{
            if(!this.state.passcode){
               this.props.notify("Please insert new password!","error");
               this.setState({loading:false})
               return false
            }        
            if(this.state.passcode.length<6) {
               this.props.notify("Password must have atlist 6 digit!","error")
               this.setState({loading:false})
               return false
            }        
            if(this.state.passcode !== "" && this.state.passcode !== this.state.repasscode){
               this.setState({loading:false})
               return false
            }        
            let body = {
              "username": this.props.user.username,
              "masterPassword": this.state.mpassword,
              "newPassword": this.state.passcode,
              "confirmPassword": this.state.repasscode
            }        
            await userService.updateUserPassword(body).then((res)=>{
              if(res.isSuccess){
                this.props.notify("Password Updated Succesfully!","success");
                this.props.closePopup()
              } else {
               this.props.notify(res.exception.message,"error")
              }
              setTimeout(()=>{ this.setState({loading:false})},1000)            
            })
         })
      }
    }
   componentDidMount() {
   }
   render() {
      return (
         <>
            <div className="modal fade show" style={{ display: 'block' }} id="mywithdraw" role="dialog" aria-modal="true">
               <div className="modal-dialog modal-dialog-scrollable">
                  <div className="modal-content">
                     <div className="modal-header">
                        <h4 className="modal-title">Change Password</h4>
                        <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.props.closePopup() }}>×</button>
                     </div>
                     <div className="modal-body lst-pop ">
                        <div className="row m-b-20">
                           <div className="col-md-4">
                              <label className="deposite-user-first">New Password</label>
                           </div>
                           <div className="col-md-8">
                              <input type="Password" autoFocus tabIndex={1} value={this.state.passcode} name="passcode" onChange={(e) => { this.onChange(e) }} />
                           </div>
                        </div>
                        <div className="row m-b-20">
                           <div className="col-md-4">
                              <label className="deposite-user-first">Confirm Password</label>
                           </div>
                           <div className="col-md-8">
                              <input type="Password" tabIndex={2} value={this.state.repasscode} name="repasscode" onChange={(e) => { this.onChange(e) }} />
                              {this.state.passcode !== "" && this.state.passcode !== this.state.repasscode ?<span style={{"color":"red","fontSize":"13px"}}>Confirm Password should match to New Password</span>:null}
                           </div>
                        </div>
                        <div className="row m-b-20">
                           <div className="col-md-4">
                              <label>Master Password</label>
                           </div>
                           <div className="col-md-8">
                              <input type="Password" onKeyUp={(e)=>{this.handleKey(e)}} tabIndex={3} name="mpassword" value={this.state.mpassword} onChange={(e) => { this.onChange(e) }} id="mpassword" required="" />
                           </div>
                        </div>
                     </div>
                     <div className="modal-footer">
                        <a  onDoubleClickCapture={(e)=>{e.preventDefault();return false;}} onClick={() => { if(!this.state.loading){this.submitForm()} }} tabIndex={4} style={{cursor: "pointer"}} className="pop-edit-btn">Submit {this.state.loading && <img style={{height:"16px"}} alt="" src={BASE_IMAGE_PATH + "/aimg/loader.gif"} />}</a>
                        &nbsp;&nbsp;
                        <a className="pop-edit-btn" tabIndex={5} style={{cursor: "pointer"}} onClick={() => { this.props.closePopup() }} data-dismiss="modal">Cancel</a>                        
                     </div>
                     {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                  </div>
               </div>
               <div className="modal-backdrop fade show" onClick={() => { this.props.closePopup() }}></div>
               </div>            
         </>
      )
   }
}

function mapStateToProps(state) {
   return {
   };
}

function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(PasswordModel);